import { MutableRefObject } from 'react'

import { SuggestedPlace } from 'libs/place/types'

import { GeolocPermissionState, GeolocPositionError } from './geolocation/enums'

export enum LocationMode {
  AROUND_ME = 'AROUND_ME',
  AROUND_PLACE = 'AROUND_PLACE',
  EVERYWHERE = 'EVERYWHERE',
}

export const enum LocationLabel {
  everywhereLabel = 'France entière',
  aroundMeLabel = 'Ma position',
}

export type GeolocationError = {
  type: GeolocPositionError
  message: string
}

export type GeoCoordinates = {
  latitude: number
  longitude: number
}

// A position is either not yet asked (undefined), refused (null) or accepted and retrieved (coordinates)
export type Position = GeoCoordinates | null | undefined

export type RequestGeolocPermissionParams = {
  onAcceptance?: () => void
  onRefusal?: () => void
  onSubmit?: () => void
}
export type AskGeolocPermission = () => Promise<GeolocPermissionState>
export type ReadGeolocPermission = () => Promise<GeolocPermissionState>

export type ILocationContext = {
  hasGeolocPosition: boolean
  place: SuggestedPlace | null
  setPlace: (place: SuggestedPlace | null) => void
  onModalHideRef: MutableRefObject<(() => void) | undefined>
  geolocPosition: Position
  geolocPositionError: GeolocationError | null
  permissionState: GeolocPermissionState | null
  requestGeolocPermission: (params?: RequestGeolocPermissionParams) => Promise<void>
  triggerPositionUpdate: () => void
  showGeolocPermissionModal: () => void
  onPressGeolocPermissionModalButton: () => void
  selectedLocationMode: LocationMode
  setSelectedLocationMode: (locationMode: LocationMode) => void
  selectedPlace: SuggestedPlace | null
  setSelectedPlace: (place: SuggestedPlace | null) => void
  onResetPlace: () => void
  placeQuery: string
  setPlaceQuery: (placeQuery: string) => void
  aroundPlaceRadius: number
  setAroundPlaceRadius: (radius: number) => void
  aroundMeRadius: number
  setAroundMeRadius: (radius: number) => void
  userLocation: Position
}
